import { ContractStatus } from './types';

// Allow moving back to draft from any state for editing
export const STATE_TRANSITIONS: Record<ContractStatus, ContractStatus[]> = {
  draft: ['review', 'archived'],
  review: ['draft', 'signature', 'archived'],
  signature: ['draft', 'review', 'executed', 'archived'],
  executed: ['draft', 'archived'],
  archived: ['draft'], // Allow unarchiving to draft
};

export function canTransition(from: ContractStatus, to: ContractStatus): boolean {
  return STATE_TRANSITIONS[from]?.includes(to) ?? false;
}

export function getNextStates(current: ContractStatus): ContractStatus[] {
  return STATE_TRANSITIONS[current] ?? [];
}

export function validateTransition(from: ContractStatus, to: ContractStatus): void {
  if (!canTransition(from, to)) {
    throw new Error(
      `Invalid state transition: cannot move from "${from}" to "${to}"`
    );
  }
}

